import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  WithOptionsFilterFilters,
} from '@/src/components/organism/Filter/types';

export const inquiryFilters: (
  inquiryCategoryOptions: { label: string; value: string }[],
) => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = inquiryCategoryOptions => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
  },
  {
    key: 'inquiryCategory',
    label: '문의 유형',
    placeholder: '전체',
    options: [{ label: '전체', value: '' }, ...inquiryCategoryOptions],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'answerCreatedAt',
    label: '답변 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['answerCreatedAtFrom', 'answerCreatedAtTo'],
  },
  {
    key: 'createdAt',
    label: '등록 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['createdAtFrom', 'createdAtTo'],
  },
  {
    key: 'content',
    label: '내용',
    placeholder: '내용을 입력해주세요',
  },
  {
    key: 'adminName',
    label: '답변 관리자',
    placeholder: '답변 관리자를 입력해주세요',
  },
  {
    key: 'inquiryAnswerStatus',
    label: '답변 상태',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: '답변 대기', value: '답변 대기' },
      { label: '답변 완료', value: '답변 완료' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'customerNick',
    label: '닉네임',
    placeholder: '닉네임을 입력해주세요',
  },
];
